export default __webpack_public_path__ + "static/media/banner (4).7ed0d9f7.jpg";